import { API } from "services/api";

export type ColetaAgendada = {
  id: number;
  carrier: "FEDEX" | "UPS";
  pickupDate: string | null;
  readyTime: string | null;
  closeTime: string | null;
  endereco: string;
  confirmationNumber: string | null;
  status: string;
  createdAt: string;
  /** Quem o motorista procura no endereço. Pode vir nulo nas coletas antigas. */
  contactName?: string | null;
  phone?: string | null;
};

export const listarColetasAgendadas = async (): Promise<ColetaAgendada[]> => {
  const { data } = await API.get("/api/coletas");
  return data;
};

/**
 * Marca a coleta como cancelada.
 *
 * Só no nosso banco: não existe Cancel Pickup (FedEx) nem Void Pickup (UPS)
 * implementado, então o agendamento continua de pé na transportadora e o
 * motorista vai aparecer. A tela avisa isso antes de confirmar.
 */
export const cancelarColeta = async (id: number) => {
  const { data } = await API.post<{ ok: boolean; ja_cancelada?: boolean }>(
    `/api/coletas/${id}/cancelar`,
  );
  return data;
};
